/**
 * THE RENTALS / REPAIR SWITCH, REMEMBERED PER BROWSER.
 *
 * The rule for who has two sides and which one they open on is in
 * src/domain/side.ts. This is only where the choice is kept: in
 * localStorage, like the theme, because it is about what the person at
 * THIS screen is doing. The yard office tablet lives on Rentals, and the
 * bay's laptop can live on Repair, and neither should flip the other.
 *
 * Every read and write is guarded. A private window, a blocked storage
 * setting or a full disk throws on the first touch, and the answer then is
 * simply the default side, not a broken bar.
 */

import { sideOf, type Side } from "../domain/side.ts";
import { currentTrade } from "./words.ts";

const KEY = "shopdesk:side";

function remembered(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

/** The side this browser is on, for the shop that is signed in. */
export function currentSide(): Side {
  return sideOf(currentTrade(), remembered());
}

export function setSide(s: Side): void {
  try { localStorage.setItem(KEY, s); } catch { /* private window: the default side it is */ }
}
